import type { ViewQueryRecordNode } from '@salescore/core'
import { Option } from 'effect'

import type { RSheetColumn, RSheetRecordNode } from '../column'
import type { RSheetsCursor } from './cursorTypes'

export const validateCursor =
  (rows: ViewQueryRecordNode[], columns: Array<RSheetColumn<RSheetRecordNode>>) =>
  (cursor: RSheetsCursor | undefined): Option.Option<RSheetsCursor> => {
    if (cursor === undefined) {
      return Option.none()
    }

    const { rowIndex, columnIndex } = cursor.main

    if (rowIndex < 0 || rows.length <= rowIndex || columnIndex < 0 || columns.length <= columnIndex) {
      return Option.none()
    }

    return Option.some(cursor)
  }
